import type { IRatePlanTaxCredit } from "@payfac/types";
import { ERatePlanTaxCapture } from "@payfac/types";

const isEmpty = (value: string | number | null | undefined) =>
  value === null || value === undefined || value === "" || `${value}` === "NaN";

export const getTabItem = (
  data: IRatePlanTaxCredit[] | undefined | null,
  type: keyof typeof ERatePlanTaxCapture,
) => {
  return Array.isArray(data)
    ? data?.find((item) => item?.[type] !== undefined)?.[type]
    : undefined;
};

export const updateTabItem = (
  data: IRatePlanTaxCredit[],
  type: keyof typeof ERatePlanTaxCapture,
  newTabData: any,
): IRatePlanTaxCredit[] => {
  const newData: IRatePlanTaxCredit[] = JSON.parse(JSON.stringify(data));
  const index = newData.findIndex((item) => item?.[type] !== undefined);

  if (index === -1) {
    newData.push({ [type]: newTabData } as IRatePlanTaxCredit);
  } else {
    newData[index] = {
      ...newData[index],
      [type]: newTabData,
    };
  }

  return newData;
};

export const manualValidate = (data: IRatePlanTaxCredit[]) => {
  let tab = undefined;

  if (
    isEmpty(getTabItem(data, ERatePlanTaxCapture.online)?.delayForRedeem) ||
    isEmpty(getTabItem(data, ERatePlanTaxCapture.pos)?.delayForRedeem) ||
    isEmpty(getTabItem(data, ERatePlanTaxCapture.tap)?.delayForRedeem)
  ) {
    return { isValid: false, tab };
  }

  const onlineData = getTabItem(data, ERatePlanTaxCapture.online);
  const hasErrorInOnline = Object.keys(onlineData || {})?.some((key) =>
    onlineData?.[key]?.sellerRates?.some((rate: string) => isEmpty(rate)),
  );

  const posData = getTabItem(data, ERatePlanTaxCapture.pos);
  const hasErrorInPos = Object.keys(posData || {})?.some((key) =>
    posData?.[key]?.sellerRates?.some((rate: string) => isEmpty(rate)),
  );

  const tapData = getTabItem(data, ERatePlanTaxCapture.tap);
  const hasErrorInTap = Object.keys(tapData || {})?.some((key) =>
    tapData?.[key]?.sellerRates?.some((rate: string) => isEmpty(rate)),
  );

  if (hasErrorInTap) {
    tab = ERatePlanTaxCapture.tap;
  }

  if (hasErrorInPos) {
    tab = ERatePlanTaxCapture.pos;
  }

  if (hasErrorInOnline) {
    tab = ERatePlanTaxCapture.online;
  }

  return {
    isValid: !hasErrorInOnline && !hasErrorInPos && !hasErrorInTap,
    tab,
  };
};

export const initialCreditData = [
  {
    online: {
      delayForRedeem: 30,
    },
  },
  {
    pos: {
      delayForRedeem: 30,
    },
  },
  {
    tap: {
      delayForRedeem: 30,
    },
  },
] as IRatePlanTaxCredit[];
